export const flatten = function (data) {

    return data.flatMap(item => {
        // Om children finns och är en array
        if (Array.isArray(item.children)) {
            return item.children.map(child => ({
                ...child,
                category: item.text,
                type: item.type
            }));
        }

        // Om inga children → behåll item själv
        return {
            ...item
        };
    });
}